import React, { useState, useEffect } from "react";
import axios from "axios";
import OtpInput from "react-otp-input";
import "./login.css";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";

function Login() {
  const [accountEmail, setAccountEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [showLoading, setShowLoading] = useState(false);

  useEffect(() => {
    if ("OTPCredential" in window) {
      navigator.credentials
        .get({ otp: { transport: ["sms"] } })
        .then((otpCredential) => setOtp(otpCredential.code))
        .catch((err) => console.error("OTP Auto-fill failed:", err));
    }
  }, []);

  const handleChange = (otp) => setOtp(otp);

  const sendOtp = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError("");
    setMessage("");

    try {
      const response = await axios.post(
        "https://musicplayer.preggyzone.com/api/register_with_otp",
        { accountEmail },
        { headers: { "Content-Type": "application/json" } }
      );

      if (response.data.result === "success") {
        setMessage("OTP Sent Successfully!");
        setOtpSent(true);
      } else {
        setError(response.data.error || "Failed to send OTP!");
      }
    } catch (error) {
      setError(error.response?.data?.message || "Failed to send OTP!");
    } finally {
      setLoading(false);
    }
  };

  const verifyOtp = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError("");
    setMessage("");

    try {
      const response = await axios.post(
        "https://musicplayer.preggyzone.com/api/register_with_otp",
        { accountEmail, otp },
        { headers: { "Content-Type": "application/json" } }
      );

      if (response.data.result === "success") {
        setMessage("OTP Verified Successfully!");
      } else {
        setError(response.data.error || "Invalid OTP. Try again!");
      }
    } catch (error) {
      setError(error.response?.data?.message || "Invalid OTP. Try again!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* Show loading screen initially */}
      {showLoading ? (
        <div className="loading-animation">
          {/* <DotLottieReact
            src="https://lottie.host/0e81359b-d3eb-4891-8085-29170a9b8a7b/kPdWLiuF3B.lottie"
            loop
            autoplay
          /> */}
        </div>
      ) : (
        <div className="page-show">
          {/* Main content */}
          <div className="login-page">
            <div className="login-container">
              <DotLottieReact
                src="https://lottie.host/c0f34415-0479-413d-82e9-347cbe998da2/io5LFeWW0t.lottie"
                loop
                autoplay
              />

              <form
                className="login-form"
                onSubmit={otpSent ? verifyOtp : sendOtp}
              >
                <h2 className="login-title">Login</h2>

                <div className="input-field">
                  <label htmlFor="email">Email *</label>
                  <input
                    type="email"
                    placeholder="Enter Email"
                    value={accountEmail}
                    onChange={(e) => setAccountEmail(e.target.value)}
                    required
                  />
                </div>

                {otpSent && (
                  <div className="otp-container">
                    <label>Enter OTP</label>
                    <OtpInput
                      type="number"
                      value={otp}
                      onChange={handleChange}
                      numInputs={6}
                      renderSeparator={<span>-</span>}
                      renderInput={(props) => (
                        <input
                          {...props}
                          autoComplete="one-time-code"
                          style={{ width: "40px" }}
                        />
                      )}
                      autoFocus
                      shouldAutoFocus
                    />
                  </div>
                )}

                <button className="submit-button" disabled={loading}>
                  {loading
                    ? "Processing..."
                    : otpSent
                    ? "Verify OTP"
                    : "Send OTP"}
                </button>

                {message && <p className="success-message">{message}</p>}
                {error && <p className="error-message">{error}</p>}
              </form>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Login;
